import type { AgentProgressEvent } from '~/components/AiChat/AgentTimeline/types';
import { PROGRESS_EVENT_KIND } from '~/components/ProgressTimeline/types';

/**
 * The four event kinds this feature defines. The same task-scoped query also carries dozens of
 * ungrouped search-agent updates per run, so anything else is dropped.
 */
export const PROGRESS_KINDS = [
  PROGRESS_EVENT_KIND.PLAN,
  PROGRESS_EVENT_KIND.STEP_STARTED,
  PROGRESS_EVENT_KIND.COMPLETED,
  PROGRESS_EVENT_KIND.FAILED,
] as const;

export type ProgressKind = (typeof PROGRESS_KINDS)[number];

export interface FnolRunState {
  activeIndex: number;
  isCompleted: boolean;
  failure?: AgentProgressEvent;
}
